import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function IterableIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box as="g" clipPath={`url(#iterable-a-${id})`}>
        <Box as="g" opacity=".25">
          <Box
            as="mask"
            id="iterable-b"
            width="12"
            height="12"
            x="8"
            y="8"
            maskUnits="userSpaceOnUse"
            sx={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M19.19 8.168H8.242v10.948H19.19V8.168Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-b-${id})`}>
            <Box as="path" fill="#59C1A7" d="m15.52 8.168-7.279 7.278 3.669 3.669 7.278-7.279-3.668-3.668Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".25">
          <Box
            as="mask"
            id={`iterable-c-${id}`}
            width="12"
            height="12"
            x="8"
            y="0"
            maskUnits="userSpaceOnUse"
            sx={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M19.145.832H8.198V11.78h10.947V.832Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-c-${id})`}>
            <Box as="path" fill="#36C3F2" d="M11.868.83 8.2 4.5l7.278 7.278 3.669-3.668-7.28-7.28Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".15">
          <Box
            as="mask"
            id={`iterable-d-${id}`}
            width="12"
            height="12"
            x="0"
            y="8"
            maskUnits="userSpaceOnUse"
            sx={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M11.754 8.175H.806v10.948h10.948V8.175Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-d-${id})`}>
            <Box as="path" fill="#EF3D55" d="M4.476 8.177.808 11.845l7.278 7.278 3.668-3.668-7.278-7.278Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".15">
          <Box
            as="mask"
            id={`iterable-e-${id}`}
            width="12"
            height="12"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
            sx={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M11.929.658H.98v10.947h10.948V.658Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-e-${id})`}>
            <Box as="path" fill="#6A266D" d="M8.257.659.98 7.937l3.668 3.669 7.278-7.279L8.257.659Z" />
          </Box>
        </Box>
        <Box as="path" fill="#6A266D" d="M9.985 0a2.614 2.614 0 0 1 0 5.225 2.614 2.614 0 0 1 0-5.225Z" />
        <Box as="path" fill="#36C3F2" d="M17.358 7.402a2.614 2.614 0 0 1 0 5.225 2.614 2.614 0 0 1 0-5.225Z" />
        <Box as="path" fill="#59C1A7" d="M9.985 14.775a2.614 2.614 0 0 1 0 5.225 2.614 2.614 0 0 1 0-5.225Z" />
        <Box as="path" fill="#EF3D55" d="M2.612 7.373a2.614 2.614 0 0 1 0 5.225 2.614 2.614 0 0 1 0-5.225Z" />
      </Box>
      <Box as="defs">
        <clipPath id={`iterable-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h19.97v20H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
